/* eslint-disable */
import React from "react";
import { useStyles } from "./styles";

export const BlockCardImg = ({ children, ...props }) => {
  const classes = useStyles(props);
  const { blockIndex } = props;

  let backroundUrl = "";
  let gradientColor = "#004A96";
  switch (blockIndex) {
    case 1:
      backroundUrl = `url("/assets/images/navBlocks/slides.png")`;
      break;
    case 2:
      backroundUrl = `url("/assets/images/navBlocks/map.png")`;
      gradientColor = "#21A0D2";
      break;
    case 3:
      backroundUrl = `url("/assets/images/navBlocks/dashboards.png")`;
      gradientColor = "#00793A";
      break;
    case 4:
      backroundUrl = `url("/assets/images/navBlocks/bulkExport.png")`;
      gradientColor = "#65AC1E";
      break;
    default:
      backroundUrl = `url("/assets/images/navBlocks/slides.png")`;
      break;
  }
  const gradient = `linear-gradient(69.3deg, ${gradientColor} 17.34%, rgba(0, 74, 150, 0) 80.27%)`;

  return (
    <div className={classes.imgRoot}>
      <div className={classes.svg}>{children}</div>
      <div className={classes.blockImg} style={{ backgroundImage: backroundUrl }}></div>
      <div className={classes.gradient} style={{ background: gradient }}></div>
    </div>
  );
};
BlockCardImg.muiName = "BlockCardImg";
BlockCardImg.displayName = "BlockCardImg";
BlockCardImg.defaultProps = {
  role: "img",
};
export default BlockCardImg;
